import { difference, isEmpty } from 'lodash';

// Moment.js tokens that are always invalid and are not supported
export const INVALID_TOKENS = [
  'Z',
  'z',
  'X',
  'x',
  'Mo',
  'Q',
  'Do',
  'do',
  'e',
  'E',
  'w',
  'W',
  'gg',
  'GG',
  'k',
  'L',
  'l',
  'T',
];

// Moment.js tokens that is supported but could be invalid sometimes
export const VALID_TOKENS = [
  'Y',
  'M',
  'D',
  'd',
  'H',
  'h',
  'm',
  's',
  'S',
  'A',
  'a',
];

export function isFormatInvalid(format, validTokens) {
  if (isEmpty(format)) {
    return true;
  }
  const invalidTokens = difference(VALID_TOKENS, validTokens).concat(
    INVALID_TOKENS
  );
  return invalidTokens.some(token => format.includes(token));
}

export function generateVegaDateTimeFormatExpression(
  customisations,
  withSpacePadding = false,
  field
) {
  const f = field || 'value';
  const format = customisations.dateTimeFormatting;

  // return value as is if date time formatting options are not applicable
  if (!format || !format.value) {
    return `datum["${f}"]`;
  }

  let vegaFormat =
    // using an invalid char Z,z instead of %,- first
    // so we don't need to worry about the special % and - while converting
    format.value
      // escape %
      .replace('%', '%%')
      // AM/PM
      .replace(/[aA]/g, 'Zp')
      // Millisecond
      .replace(/SSS/g, 'ZL')
      .replace(/SS/g, 'ZzL')
      .replace(/S/g, 'ZzL')
      // Second
      .replace(/ss/g, 'ZS')
      .replace(/s/g, 'ZzS')
      // Hour 24-hour clock
      .replace(/HH/g, 'ZH')
      .replace(/^H/, 'ZzH') // leading H
      .replace(/([^Zz])H/g, '$1ZzH') // non-leading H
      // Hour 12-hour clock
      .replace(/hh/g, 'ZI')
      .replace(/h/g, 'ZzI')
      // Year
      .replace(/YYYY/g, 'ZY')
      .replace(/^YY/, 'Zy') // leading YY
      .replace(/([^Z])YY/g, '$1Zy') // non-leading YY
      .replace(/^Y/, 'ZY') // leading Y
      .replace(/([^Z])Y/g, '$1ZY') // non-leading Y
      // Month
      .replace(/MMMM/g, 'ZB')
      .replace(/MMM/g, 'Zb')
      .replace(/MM/g, 'Zm')
      .replace(/M/g, 'Zzm')
      // Minute
      .replace(/^mm/, 'ZM') // leading mm
      .replace(/([^Zz])mm/g, '$1ZM') // non-leading mm
      .replace(/^m/, 'ZzM') // leading m
      .replace(/([^Zz])m/g, '$1ZzM') // non-leading m
      // Day of week
      .replace(/dddd/g, 'ZA')
      .replace(/ddd/g, 'Za')
      .replace(/dd/g, 'Za')
      .replace(/d/g, 'Zw')
      // Day of year
      .replace(/DDDD/g, 'Zj')
      .replace(/DDD/g, 'Zzj')
      // Day of month
      .replace(/DD/g, 'Zd')
      .replace(/D/g, 'Zzd')
      // replace Z back to %
      .replace(/Z/g, '%')
      // replace z back to -
      .replace(/z/g, '-');
  if (withSpacePadding) {
    // Vega 4 runs horizontal labels very close together. When this option is on we add spaces before
    // and after to prevent the labels being too close. If we later move to Vega 5 we can replace this
    // with the labelSeparation option.
    vegaFormat = ` ${vegaFormat} `;
  }
  return `isDate(datum["${f}"]) ? utcFormat(datum["${f}"], "${vegaFormat}") : "Invalid Date"`;
}
